import * as React from 'react';

import type { SidePanelItem } from 'types';

type Props = {
  item: SidePanelItem
};

const SidePanelItemGeneric = ({
  item
}: Props) => (
  <span onClick={item.meta && item.meta.onClick}>{item.text}</span>
);

export default SidePanelItemGeneric;
